import React, { useCallback, useContext } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { useHistory } from 'react-router-dom';
// import { unsubscribeRealtimeUpdates } from '../../system/firebase';
import { useLocation, useParams } from 'react-router-dom';

// import { useTheme } from '@material-ui/core/styles';
// import useMediaQuery from '@material-ui/core/useMediaQuery';

import { PATH_JOB_CENTER, PATH_HOME, PATH_SUB_PAGE_TERMS, PATH_SUB_PAGE_PRIVACY, PATH_SUB_PAGE_FAQ, PATH_RESOURCE_CENTER, PATH_DASHBOARD } from '../../system/constants';
import { AppContext, LayoutContext } from '../../common/contexts';
import {
    DASHBOARD_MY_PROFILE,
    DASHBOARD_MY_CALENDAR,
    DASHBOARD_MY_JOBS,
    DASHBOARD_MY_SETTINGS,
    DASHBOARD_MY_MESSAGES,
    DASHBOARD_JOB_CENTER,
    BASE_URL,
    DASHBOARD_ID_MY_SETTINGS,
    DASHBOARD_ID_MY_PROFILE,
    DASHBOARD_ID_MY_JOBS,
    DASHBOARD_ID_MY_MESSAGES,
    DASHBOARD_ID_MY_CALENDAR,
    HOMEPAGE_ABOUT,
    HOMEPAGE_CONTACT,
    HOMEPAGE_FAQ,
} from '../../common/constants';

//---------------------------------------------------------------------
// Page specific helpers and constants imports
//---------------------------------------------------------------------
import { isOnPage } from '../../system/helpers/systemHelper';
import { getMyCalendarCaption } from '../../common/calendarHelper';
import { setClassNameInDefns } from '../../common/definitionHelper';

//---------------------------------------------------------------------
// Page specific components imports
//---------------------------------------------------------------------
import NavigationButton from '../../dashboard/subComponents/NavigationButton';

import AfitdBox from '../../common/elemental/AfitdBox';
import TopNavButton from './TopNavButton';

import _get from 'lodash/get';
import _reduce from 'lodash/reduce';
import _keys from 'lodash/keys';
import _noop from 'lodash/noop';
import { Grid, Popover } from '@material-ui/core';

const styles = theme => ({
    root: {
        backgroundColor: '#FAFAFC',
        height: '100%',
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
    },
    // footer style
    footerRoot: {
        height: '100%',
        flexDirection: 'column',
        justifyContent: 'flex-end',
        marginBottom: 24,
        marginTop: '25px',

        // added below lines
        [theme.breakpoints.down('md')]: {
            paddingTop: 24,
            flexDirection: 'row',
        },
    },
    footerLinks: {
        display: 'flex',
        justifyContent: 'center',
    },
    footerText: {
        fontSize: '14px',
        color: 'rgba(17, 40, 20, 0.4)',
    },
    separator: {
        fontSize: '14px',
        color: 'rgba(17, 40, 20, 0.4)',
        margin: '0 4px',
    },
    copyright: {
        textAlign: 'center',
        color: 'rgba(17, 40, 20, 0.4)',
        margin: '12px 0',
    },
    resourceCenterButtonContainer: { marginLeft: '40px' },
    resourceCenterButtonSection: {
        margin: 'auto',
    },
    NavigationButtonContainer: { borderTop: '1px solid #F0F2F6', paddingTop: 15, paddingBottom: 15, width: 370 },
    dashboardButtonContainer: { marginLeft: '40px', [theme.breakpoints.down('md')]: { margin: 'auto', marginLeft: '44px' } },
    myProfileButton: {
        color: 'red',
        '&:hover': { border: '1px solid #1D8A8B' },
    },
});

const getDefns = params => {
    const { props, profilePicUrl, dashboardData, currentThreadId, handleClickJobCenterButton, history, location, pageId } = params;
    const {
        classes,
        classes: { root: rootCls },
    } = props;

    const unreadMessagesCounts = _get(dashboardData, 'unreadMsgsCounts');
    const threadIdList = _keys(unreadMessagesCounts);
    const unreadMessagesCount = _reduce(threadIdList, (total, threadId) => (threadId !== currentThreadId ? total + _get(unreadMessagesCounts, threadId, 0) : total), 0);

    const myCalendarCaption = getMyCalendarCaption({ dashboardData });
    const dashboardButtonIsHidden = isOnPage(location, PATH_DASHBOARD); //|| isOnPage(location, '/', true);
    const isOnJobCenterPage = isOnPage(location, PATH_JOB_CENTER);

    const defns = {
        root: {
            className: rootCls,
        },
        photoSection: {
            photoUrl: profilePicUrl,
        },
        myProfileButton: {
            label: DASHBOARD_MY_PROFILE,
            selected: pageId === DASHBOARD_ID_MY_PROFILE,
            onClick: handleClickButton.bind(null, history, `${PATH_DASHBOARD}/${DASHBOARD_ID_MY_PROFILE}`),
        },
        myCalendarButton: {
            label: DASHBOARD_MY_CALENDAR,
            selected: pageId === DASHBOARD_ID_MY_CALENDAR,
            onClick: handleClickButton.bind(null, history, `${PATH_DASHBOARD}/${DASHBOARD_ID_MY_CALENDAR}`),
            caption: myCalendarCaption,
        },
        myJobsButton: {
            label: DASHBOARD_MY_JOBS,
            selected: pageId === DASHBOARD_ID_MY_JOBS,
            onClick: handleClickButton.bind(null, history, `${PATH_DASHBOARD}/${DASHBOARD_ID_MY_JOBS}`),
        },
        mySettingsButton: {
            label: DASHBOARD_MY_SETTINGS,
            selected: pageId === DASHBOARD_ID_MY_SETTINGS,
            onClick: handleClickButton.bind(null, history, `${PATH_DASHBOARD}/${DASHBOARD_ID_MY_SETTINGS}`),
        },
        myMessagesButton: {
            label: DASHBOARD_MY_MESSAGES,
            selected: pageId === DASHBOARD_ID_MY_MESSAGES,
            onClick: handleClickButton.bind(null, history, `${PATH_DASHBOARD}/${DASHBOARD_ID_MY_MESSAGES}`),
            caption: unreadMessagesCount,
        },
        jobCenterButton: {
            label: DASHBOARD_JOB_CENTER,
            selected: isOnJobCenterPage,
            onClick: handleClickJobCenterButton,
        },
        copyright: {
            variant: 'caption',
        },

        aboutLink: {
            onClick: handleClickButton.bind(null, history, `${PATH_HOME}/${HOMEPAGE_ABOUT}`),
        },
        contactUsLink: {
            onClick: handleClickButton.bind(null, history, `${PATH_HOME}/${HOMEPAGE_CONTACT}`),
        },
        FAQLink: {
            onClick: handleClickButton.bind(null, history, `${PATH_HOME}/${HOMEPAGE_FAQ}/${PATH_SUB_PAGE_FAQ}`),
        },
        termsOfUseLink: {
            onClick: handleClickButton.bind(null, history, `${PATH_HOME}/${HOMEPAGE_FAQ}/${PATH_SUB_PAGE_TERMS}`),
        },
        privacyLink: {
            onClick: handleClickButton.bind(null, history, `${PATH_HOME}/${HOMEPAGE_FAQ}/${PATH_SUB_PAGE_PRIVACY}`),
        },
        resourceCenterButton: {
            onClick: handleClickButton.bind(null, history, PATH_RESOURCE_CENTER),
            label: 'Resource Center',
        },
        dashboardButtonContainer: {
            isHidden: dashboardButtonIsHidden,
        },
        dashboardButton: {
            // onClick: handleClickButton.bind(null, history, PATH_DASHBOARD),
            label: 'My Dashboard',
        },
    };

    setClassNameInDefns(defns, classes);

    return defns;
};

const handleClickButton = (history, path) => {
    history.push(`${BASE_URL}${path}`);
};
const DashboardPopover = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------
    const appContext = useContext(AppContext);
    const { currentUser } = appContext;
    const profilePicUrl = _get(currentUser, 'profilePicUrl');
    const context = useContext(LayoutContext);
    const { dashboard, setCurrentDashboard = _noop, dashboardData, currentThreadId } = context;
    const history = useHistory();
    const { pageId } = useParams();
    const location = useLocation();

    // const theme = useTheme();
    // const lgMatches = useMediaQuery(theme.breakpoints.down('lg'));

    // popover

    const [anchorEl, setAnchorEl] = React.useState(null);
    const handleClick = event => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    //---------------------------------------------------------------------
    // Local states
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // useCallback
    //---------------------------------------------------------------------
    const handleClickJobCenterButton = useCallback(() => {
        history.push(`${BASE_URL}${PATH_JOB_CENTER}`);
    }, [history]);

    //---------------------------------------------------------------------
    // Defns
    //---------------------------------------------------------------------
    const defns = getDefns({ props, profilePicUrl, dashboard, setCurrentDashboard, dashboardData, currentThreadId, handleClickJobCenterButton, history, location, pageId });

    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------
    return (
        <div>
            <div>
                <div aria-describedby={id} variant="contained" onClick={handleClick}>
                    <AfitdBox {...defns.dashboardButtonContainer}>
                        <TopNavButton {...defns.dashboardButton} />
                    </AfitdBox>
                </div>
                <Popover
                    id={id}
                    open={open}
                    anchorEl={anchorEl}
                    onClose={handleClose}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                >
                    <div {...defns.NavigationButtonContainer}>
                        <Grid container justify="space-evenly">
                            <Grid item xl={4} lg={4} md={4} sm={4} xs={5}>
                                <NavigationButton {...defns.myProfileButton} />
                            </Grid>
                            <Grid item xl={4} lg={4} md={4} sm={4} xs={5}>
                                <NavigationButton {...defns.myCalendarButton} />
                            </Grid>
                        </Grid>
                        <Grid container justify="space-evenly">
                            <Grid item xl={4} lg={4} md={4} sm={4} xs={5}>
                                <NavigationButton {...defns.myJobsButton} />
                            </Grid>
                            <Grid item xl={4} lg={4} md={4} sm={4} xs={5}>
                                <NavigationButton {...defns.myMessagesButton} />
                            </Grid>
                        </Grid>
                        <Grid container justify="space-evenly">
                            <Grid item xl={4} lg={4} md={4} sm={4} xs={5}>
                                <NavigationButton {...defns.jobCenterButton} />
                            </Grid>
                            <Grid item xl={4} lg={4} md={4} sm={4} xs={5}>
                                <NavigationButton {...defns.mySettingsButton} />
                            </Grid>
                        </Grid>
                    </div>
                </Popover>
            </div>
        </div>
    );
};

export default withStyles(styles)(DashboardPopover);
